import React from 'react';
import {Flex} from '/app/src/component';

const titleWrapper = {
    marginRight: '15px',
    hAlignContent: 'right'
}

const titleStyle = {
    width: '50%',
}

const summaryRowContainer = {
    marginBottom: '8px',
}

export default function SummaryRow({title, infoList, textAlign, textColor, size, emphasize}) {
    const fontSize = emphasize ? '22px' : '18px'
    const textStyle = {
        color: textColor || 'DarkGray',
        fontSize: fontSize,
        hAlignContent: textAlign || 'left',
        wordBreak: 'break-all',
        width: '50%'
    }
    return (
        <Flex {...summaryRowContainer}>
            <Flex {...textStyle} {...titleWrapper} {...titleStyle}>
                {title}
            </Flex>
            <Flex {...textStyle} column>
                {infoList.map((item, i) => {
                    return (<Flex key={i}>
                        {item}
                    </Flex>)
                })}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/SummaryRow.js